import { Alert, Grid, TableCell, TableRow } from '@mui/material';
import { ILegalClient } from '../Interfaces/ILegalClient';
import { getDebtorWarnings } from './debtorWarnings';

interface Props {
  /** Aufgelöste Schuldner-Objekte der Rechnung (invoice.LegalClients). */
  debtors: ILegalClient[];
  /** Wrapper je nach Kontext: Tabellenzeile (InvoiceRow) oder Grid-Item (InvoiceEdit). */
  layout: 'tableRow' | 'gridItem';
  /** Nur für layout='tableRow': Spaltenanzahl für den colSpan. */
  colSpan?: number;
}

/**
 * Rendert die Zahlungsschuldner-Warnleisten (#1183 + #1185) als volle-Breite-
 * Alerts — je nach Kontext als Tabellenzeile oder Grid-Item.
 */
export const DebtorWarningBars = ({ debtors, layout, colSpan }: Props) => {
  const warnings = getDebtorWarnings(debtors);
  if (warnings.length === 0) return null;

  if (layout === 'tableRow') {
    return (
      <>
        {warnings.map(warning => (
          <TableRow key={warning.severity}>
            <TableCell colSpan={colSpan} sx={{ p: 0, borderBottom: 'none' }}>
              <Alert
                severity={warning.severity}
                sx={{ borderRadius: 0, py: 0.25 }}
              >
                {warning.text}
              </Alert>
            </TableCell>
          </TableRow>
        ))}
      </>
    );
  }

  return (
    <>
      {warnings.map(warning => (
        <Grid item xs={12} key={warning.severity}>
          <Alert severity={warning.severity} sx={{ py: 0.25 }}>
            {warning.text}
          </Alert>
        </Grid>
      ))}
    </>
  );
};
